enum AgeEnum {
    DARK_AGE = 0,
    FEUDAL_AGE = 1,
    CASTLE_AGE = 2,
    IMPERIAL_AGE = 3
}

export default AgeEnum;
